import { DeliveryMethodModel } from '@/http/models/DeliveryMethod'

import { useFetchList } from '@/hooks/useFetchList'

import { DeliveryMethodHttpParams, DeliveryMethodModel as DeliveryMethodType } from '@/types'

export interface DeliveryMethodFilters {
  status?: 'active' | 'inactive' | null
}

interface UseFetchDeliveryMethodsProps {
  sort?: string | null
  status?: 'active' | 'inactive'
}

export const useFetchDeliveryMethods = ({ sort, status }: UseFetchDeliveryMethodsProps = {}) => {
  return useFetchList<
    DeliveryMethodFilters,
    DeliveryMethodType.DeliveryMethod,
    {},
    any,
    typeof DeliveryMethodModel.getList
  >({
    pageSize: 10,
    initialFilters: {
      status: status || null,
    },
    fetchFunction: DeliveryMethodModel.getList,
    sort,
    buildQueryParams: (filters): Partial<DeliveryMethodHttpParams.GetList['query']> => ({
      status: filters.status || undefined,
    }),
  })
}
